{
    "RTE_Label": "Start typing...",
    "NAME": "RichTextEditor"
}